var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "sessionDetails" } }, [
    _c("div", { staticClass: "sl-row" }, [
      _c(
        "div",
        { staticClass: "sl-col-6" },
        [
          _c("h5", [_vm._v("Affiliate")]),
          _c(
            "q-field",
            {
              staticStyle: { "margin-top": "12px" },
              attrs: {
                error: _vm.classValidation.selectedAffiliate.$error,
                "error-label": "Required",
                helper: _vm.currentAffiliateLabel
              }
            },
            [
              _c(
                "q-input",
                {
                  attrs: {
                    before: [{ icon: "fa fa-building" }],
                    after: [
                      {
                        icon: "flag",
                        condition:
                          _vm.classValidation.selectedAffiliate.$invalid
                      },
                      {
                        icon: "fa fa-check",
                        condition: !_vm.classValidation.selectedAffiliate
                          .$invalid
                      }
                    ],
                    placeholder: "Search for Affiliate",
                    disable: !_vm.canEdit,
                    "clear-value": null,
                    clearable: ""
                  },
                  on: {
                    blur: _vm.classValidation.selectedAffiliate.$touch,
                    clear: function($event) {
                      _vm.loadInstructorsForAffiliateMethod()
                    }
                  },
                  model: {
                    value: _vm.affiliateFilter,
                    callback: function($$v) {
                      _vm.affiliateFilter = $$v
                    },
                    expression: "affiliateFilter"
                  }
                },
                [
                  _c("q-autocomplete", {
                    attrs: { debounce: 500, "max-results": 10 },
                    on: {
                      search: _vm.onAffiliateAutocomplete,
                      selected: _vm.onSelectAffiliate
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "sl-col-6" }, [
        _c(
          "h5",
          [
            _vm._v("\n        Instructors\n        "),
            ((!_vm.currentSession().syncInstructors && !_vm.isFirstSession()) ||
              _vm.isFirstSession()) &&
            _vm.canEdit &&
            _vm.sessionInformation.selectedAffiliate &&
            _vm.remainingInstructorsCount > 0
              ? _c(
                  "q-btn",
                  {
                    attrs: { icon: "add", id: "addInstructor" },
                    on: {
                      click: function($event) {
                        _vm.updateAddNewInstructor({
                          sessionIndex: _vm.currentSessionOrFirst(
                            "Instructors",
                            true
                          )
                        })
                      }
                    }
                  },
                  [
                    _c(
                      "q-tooltip",
                      {
                        attrs: {
                          anchor: "center right",
                          self: "center left",
                          offset: [10, 10]
                        }
                      },
                      [_vm._v("Add an Instructor")]
                    )
                  ],
                  1
                )
              : _vm._e(),
            !_vm.isFirstSession()
              ? _c(
                  "span",
                  [
                    _c("q-checkbox", {
                      attrs: { disable: !_vm.canEdit },
                      model: {
                        value: _vm.currentSession().syncInstructors,
                        callback: function($$v) {
                          _vm.$set(_vm.currentSession(), "syncInstructors", $$v)
                        },
                        expression: "currentSession().syncInstructors"
                      }
                    }),
                    _c("span", [_vm._v("Sync with First Session")])
                  ],
                  1
                )
              : _vm._e(),
            _vm.currentSessionOrFirst("Instructors").instructors.length === 0 &&
            _vm.canEdit &&
            _vm.sessionInformation.selectedAffiliate &&
            _vm.remainingInstructorsCount > 0
              ? _c(
                  "q-btn",
                  {
                    attrs: { color: "red" },
                    on: {
                      click: function($event) {
                        _vm.updateAddNewInstructor({
                          sessionIndex: _vm.currentSessionOrFirst(
                            "Instructors",
                            true
                          )
                        })
                      }
                    }
                  },
                  [_c("span", [_vm._v("Please Add an Instructor!")])]
                )
              : _vm._e(),
            !_vm.sessionInformation.selectedAffiliate
              ? _c("span", { staticClass: "no-affiliate-label" }, [
                  _vm._v("Please select an affiliate!")
                ])
              : _vm._e(),
            _vm.sessionInformation.selectedAffiliate &&
            _vm.sessionInformation.availableInstructors.length == 0
              ? _c("span", { staticClass: "no-affiliate-label" }, [
                  _vm._v("No Instructors Associated to this Affiliate.")
                ])
              : _vm._e()
          ],
          1
        ),
        _vm.sessionInformation.availableInstructors.length > 0
          ? _c(
              "div",
              { staticClass: "sl-row" },
              _vm._l(
                _vm.currentSessionOrFirst("Instructors").instructors,
                function(instructor, i) {
                  return _c(
                    "div",
                    { key: i, staticClass: "sl-col-12 instructor-field" },
                    [
                      _c(
                        "q-field",
                        {
                          attrs: {
                            error: _vm.currentSessionOrFirst("Instructors")
                              .instructors[i].value,
                            "error-label": "Instructor is required"
                          }
                        },
                        [
                          _c("q-select", {
                            ref: "instructorDropdowns",
                            refInFor: true,
                            attrs: {
                              disable: !_vm.canEdit,
                              before: [{ icon: "fa fa-graduation-cap" }],
                              options: _vm.remainingInstructors(instructor),
                              placeholder: "Select Instructor",
                              "float-label": "Instructor",
                              filter: "",
                              "autofocus-filter": ""
                            },
                            model: {
                              value: _vm.currentSessionOrFirst("Instructors")
                                .instructors[i],
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.currentSessionOrFirst("Instructors")
                                    .instructors,
                                  i,
                                  $$v
                                )
                              },
                              expression:
                                "currentSessionOrFirst('Instructors').instructors[i]"
                            }
                          })
                        ],
                        1
                      ),
                      _vm.canEdit
                        ? _c("q-btn", {
                            staticClass: "delete",
                            attrs: {
                              outline: "",
                              color: "red",
                              icon: "fa fa-trash-o"
                            },
                            nativeOn: {
                              click: function($event) {
                                _vm.updateAddNewInstructor({
                                  instructorIndex: i,
                                  sessionIndex: _vm.currentSessionOrFirst(
                                    "Instructors",
                                    true
                                  ),
                                  delete: true
                                })
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                }
              )
            )
          : _vm._e()
      ])
    ]),
    _vm._m(0),
    _c("div", { staticClass: "sl-row" }, [
      _c(
        "div",
        { staticClass: "sl-col-6 time-container" },
        [
          _c(
            "q-field",
            {
              staticStyle: { width: "40%", "margin-right": "4%" },
              attrs: {
                error: _vm.currentValidation().startDate.$error,
                "error-label": "Start Date Required"
              }
            },
            [
              _c("q-datetime", {
                attrs: {
                  disable: !_vm.canEdit,
                  max: _vm.currentSession().endDate,
                  min: _vm.$p(["ADMIN"]) ? null : _vm.currentSession().minStart,
                  before: [{ icon: "calendar_today" }],
                  "inverted-light": "",
                  color: "grey-3",
                  type: "date",
                  format: "MM/DD/YYYY",
                  "float-label": "Start Date*",
                  popover: ""
                },
                on: {
                  blur: function($event) {
                    _vm.currentValidation().startDate.$touch
                    _vm.ifEmptySetEndDate()
                  }
                },
                model: {
                  value: _vm.currentSession().startDate,
                  callback: function($$v) {
                    _vm.$set(_vm.currentSession(), "startDate", $$v)
                  },
                  expression: "currentSession().startDate"
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            {
              staticStyle: { width: "15%" },
              attrs: {
                error: _vm.currentValidation().startHour.$error,
                "error-label": "Required"
              }
            },
            [
              _c("q-select", {
                attrs: {
                  disable: !_vm.canEdit,
                  "stack-label": "Time*",
                  value: _vm.currentSession().startHour,
                  filter: "",
                  "autofocus-filter": "",
                  options: _vm.hours
                },
                on: {
                  blur: function($event) {
                    _vm.currentValidation().startHour.$touch
                  }
                },
                model: {
                  value: _vm.currentSession().startHour,
                  callback: function($$v) {
                    _vm.$set(_vm.currentSession(), "startHour", $$v)
                  },
                  expression: "currentSession().startHour"
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            {
              staticStyle: { width: "15%" },
              attrs: {
                error: _vm.currentValidation().startMin.$error,
                "error-label": "Required"
              }
            },
            [
              _c("q-select", {
                attrs: {
                  disable: !_vm.canEdit,
                  "float-label": " ",
                  value: _vm.currentSession().startMin,
                  filter: "",
                  "autofocus-filter": "",
                  options: _vm.minutes
                },
                on: {
                  blur: function($event) {
                    _vm.currentValidation().startMin.$touch
                  }
                },
                model: {
                  value: _vm.currentSession().startMin,
                  callback: function($$v) {
                    _vm.$set(_vm.currentSession(), "startMin", $$v)
                  },
                  expression: "currentSession().startMin"
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            {
              staticStyle: { width: "15%" },
              attrs: {
                error: _vm.currentValidation().startPeriod.$error,
                "error-label": "Required"
              }
            },
            [
              _c("q-select", {
                attrs: {
                  disable: !_vm.canEdit,
                  "float-label": " ",
                  value: _vm.currentSession().startPeriod,
                  filter: "",
                  "autofocus-filter": "",
                  options: _vm.period
                },
                on: {
                  blur: function($event) {
                    _vm.currentValidation().startPeriod.$touch
                  }
                },
                model: {
                  value: _vm.currentSession().startPeriod,
                  callback: function($$v) {
                    _vm.$set(_vm.currentSession(), "startPeriod", $$v)
                  },
                  expression: "currentSession().startPeriod"
                }
              })
            ],
            1
          ),
          _vm.currentSession().invalidStart
            ? _c(
                "span",
                { staticClass: "repair-date-helper text-green" },
                [
                  _c("q-icon", {
                    attrs: { name: "fa fa-wrench", color: "green" }
                  }),
                  _vm._v(" Auto-repaired Start Date\n      ")
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "sl-col-6 time-container" },
        [
          _c(
            "q-field",
            {
              staticStyle: { width: "40%", "margin-right": "4%" },
              attrs: {
                error: _vm.currentValidation().endDate.$error,
                "error-label": "End Date Required"
              }
            },
            [
              _c("q-datetime", {
                attrs: {
                  disable: !_vm.canEdit,
                  min: _vm.currentSession().startDate,
                  before: [{ icon: "calendar_today" }],
                  "inverted-light": "",
                  color: "grey-3",
                  type: "date",
                  format: "MM/DD/YYYY",
                  "float-label": "End Date*",
                  popover: ""
                },
                on: {
                  blur: function($event) {
                    _vm.currentValidation().endDate.$touch
                  }
                },
                model: {
                  value: _vm.currentSession().endDate,
                  callback: function($$v) {
                    _vm.$set(_vm.currentSession(), "endDate", $$v)
                  },
                  expression: "currentSession().endDate"
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            {
              staticStyle: { width: "15%" },
              attrs: {
                error: _vm.currentValidation().endHour.$error,
                "error-label": "Required"
              }
            },
            [
              _c("q-select", {
                attrs: {
                  disable: !_vm.canEdit,
                  "stack-label": "Time*",
                  value: _vm.currentSession().endHour,
                  filter: "",
                  "autofocus-filter": "",
                  options: _vm.hours
                },
                on: {
                  blur: function($event) {
                    _vm.currentValidation().endHour.$touch
                  }
                },
                model: {
                  value: _vm.currentSession().endHour,
                  callback: function($$v) {
                    _vm.$set(_vm.currentSession(), "endHour", $$v)
                  },
                  expression: "currentSession().endHour"
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            {
              staticStyle: { width: "15%" },
              attrs: {
                error: _vm.currentValidation().endMin.$error,
                "error-label": "Required"
              }
            },
            [
              _c("q-select", {
                attrs: {
                  disable: !_vm.canEdit,
                  "float-label": " ",
                  value: _vm.currentSession().endMin,
                  filter: "",
                  "autofocus-filter": "",
                  options: _vm.minutes
                },
                on: {
                  blur: function($event) {
                    _vm.currentValidation().endMin.$touch
                  }
                },
                model: {
                  value: _vm.currentSession().endMin,
                  callback: function($$v) {
                    _vm.$set(_vm.currentSession(), "endMin", $$v)
                  },
                  expression: "currentSession().endMin"
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            {
              staticStyle: { width: "15%" },
              attrs: {
                error: _vm.currentValidation().endPeriod.$error,
                "error-label": "Required"
              }
            },
            [
              _c("q-select", {
                attrs: {
                  disable: !_vm.canEdit,
                  "float-label": " ",
                  value: _vm.currentSession().endPeriod,
                  filter: "",
                  "autofocus-filter": "",
                  options: _vm.period
                },
                on: {
                  blur: function($event) {
                    _vm.currentValidation().endPeriod.$touch
                  }
                },
                model: {
                  value: _vm.currentSession().endPeriod,
                  callback: function($$v) {
                    _vm.$set(_vm.currentSession(), "endPeriod", $$v)
                  },
                  expression: "currentSession().endPeriod"
                }
              })
            ],
            1
          ),
          _vm.currentSession().invalidEnd
            ? _c(
                "span",
                { staticClass: "repair-date-helper text-green" },
                [
                  _c("q-icon", {
                    attrs: { name: "fa fa-wrench", color: "green" }
                  }),
                  _vm._v(" Auto-repaired End Date\n      ")
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ]),
    _c("div", { staticClass: "sl-row" }, [
      _c("div", { staticClass: "sl-col-12" }, [
        _c("h5", [
          _vm._v("\n        Location\n        "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isFirstSession(),
                  expression: "!isFirstSession()"
                }
              ]
            },
            [
              _c("q-checkbox", {
                attrs: { disable: !_vm.canEdit },
                model: {
                  value: _vm.currentSession().syncAddress,
                  callback: function($$v) {
                    _vm.$set(_vm.currentSession(), "syncAddress", $$v)
                  },
                  expression: "currentSession().syncAddress"
                }
              }),
              _c("span", [_vm._v("Sync with First Session")])
            ],
            1
          )
        ])
      ])
    ]),
    _c("div", { staticClass: "sl-row" }, [
      _c(
        "div",
        { staticClass: "sl-col-6" },
        [
          _c(
            "q-field",
            {
              attrs: {
                error: _vm.checkAddressError("address1"),
                "error-label": "Address is required"
              }
            },
            [
              _c("q-input", {
                directives: [
                  {
                    name: "places-autocomplete",
                    rawName: "v-places-autocomplete",
                    value: _vm.placeChange,
                    expression: "placeChange"
                  }
                ],
                ref: "googleAutocomplete",
                attrs: {
                  "float-label": "Address 1*",
                  autocomplete: "new-password",
                  disable: _vm.disableAddressForCurrentSession() || !_vm.canEdit
                },
                model: {
                  value: _vm.currentSessionOrFirst("Address").address1,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.currentSessionOrFirst("Address"),
                      "address1",
                      $$v
                    )
                  },
                  expression: "currentSessionOrFirst('Address').address1"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "sl-col-6" },
        [
          _c("q-input", {
            attrs: {
              "float-label": "Address 2",
              autocomplete: "new-password",
              disable: _vm.disableAddressForCurrentSession() || !_vm.canEdit
            },
            model: {
              value: _vm.currentSessionOrFirst("Address").address2,
              callback: function($$v) {
                _vm.$set(_vm.currentSessionOrFirst("Address"), "address2", $$v)
              },
              expression: "currentSessionOrFirst('Address').address2"
            }
          })
        ],
        1
      )
    ]),
    _c("div", { staticClass: "sl-row" }, [
      _c(
        "div",
        { staticClass: "sl-col-4" },
        [
          _c(
            "q-field",
            {
              attrs: {
                "error-label": "City is required",
                error: _vm.checkAddressError("city")
              }
            },
            [
              _c("q-input", {
                attrs: {
                  "float-label": "City*",
                  autocomplete: "new-password",
                  disable: _vm.disableAddressForCurrentSession() || !_vm.canEdit
                },
                model: {
                  value: _vm.currentSessionOrFirst("Address").city,
                  callback: function($$v) {
                    _vm.$set(_vm.currentSessionOrFirst("Address"), "city", $$v)
                  },
                  expression: "currentSessionOrFirst('Address').city"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "sl-col-2" },
        [
          _c(
            "q-field",
            {
              attrs: {
                "error-label": "State is required",
                error: _vm.checkAddressError("state")
              }
            },
            [
              _c("q-select", {
                ref: "sessionStateDropdown" + _vm.currentSessionIndex,
                attrs: {
                  disable:
                    _vm.disableAddressForCurrentSession() || !_vm.canEdit,
                  "float-label": "State*",
                  value: _vm.currentSession().state,
                  filter: "",
                  "autofocus-filter": "",
                  options: _vm.stateOptions
                },
                on: {
                  focus: function($event) {
                    _vm.onDropdownFocus(
                      "sessionStateDropdown" + _vm.currentSessionIndex
                    )
                  }
                },
                model: {
                  value: _vm.currentSessionOrFirst("Address").state,
                  callback: function($$v) {
                    _vm.$set(_vm.currentSessionOrFirst("Address"), "state", $$v)
                  },
                  expression: "currentSessionOrFirst('Address').state"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "sl-col-3" },
        [
          _c(
            "q-field",
            {
              attrs: {
                "error-label": "ZIP Code is required",
                error: _vm.checkAddressError("zip")
              }
            },
            [
              _c("q-input", {
                attrs: {
                  autocomplete: "new-password",
                  "float-label": "Zip*",
                  disable: _vm.disableAddressForCurrentSession() || !_vm.canEdit
                },
                model: {
                  value: _vm.currentSessionOrFirst("Address").zip,
                  callback: function($$v) {
                    _vm.$set(_vm.currentSessionOrFirst("Address"), "zip", $$v)
                  },
                  expression: "currentSessionOrFirst('Address').zip"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "sl-col-3" },
        [
          _c(
            "q-field",
            {
              attrs: {
                "error-label": "County is required",
                error: _vm.checkAddressError("county")
              }
            },
            [
              _c("q-input", {
                attrs: {
                  autocomplete: "new-password",
                  "float-label": "County*",
                  disable: _vm.disableAddressForCurrentSession() || !_vm.canEdit
                },
                model: {
                  value: _vm.currentSessionOrFirst("Address").county,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.currentSessionOrFirst("Address"),
                      "county",
                      $$v
                    )
                  },
                  expression: "currentSessionOrFirst('Address').county"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._m(1),
    _c("div", { staticClass: "sl-row" }, [
      _c(
        "div",
        { staticClass: "sl-col-6" },
        [
          _c(
            "q-field",
            [
              _c("q-select", {
                attrs: {
                  value: _vm.sessionInformation.selectedClassType,
                  "float-label": "Selected Type",
                  "map-options": "",
                  after: [
                    {
                      icon: "groups",
                      condition: _vm.sessionInformation.selectedClassType === 1
                    },
                    {
                      icon: "screen_share",
                      condition: _vm.sessionInformation.selectedClassType === 2
                    }
                  ],
                  disable: !_vm.canEdit,
                  options: _vm.classTypes
                },
                on: {
                  input: function(v) {
                    return _vm.onUpdateSelectedClassType(v)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm.sessionInformation.selectedClassType === 2
      ? _c("div", { staticClass: "sl-row" }, [
          _c(
            "div",
            { staticClass: "sl-col-6" },
            [
              _c("q-input", {
                attrs: {
                  "float-label": "Meeting Link",
                  before: [{ icon: "link" }]
                },
                model: {
                  value: _vm.sessionInformation.meetingLink,
                  callback: function($$v) {
                    _vm.$set(_vm.sessionInformation, "meetingLink", $$v)
                  },
                  expression: "sessionInformation.meetingLink"
                }
              }),
              _vm.isValidMeetingLink
                ? _c("q-btn", {
                    staticClass: "q-mt-sm",
                    attrs: {
                      color: "blue",
                      icon: "email",
                      label: "Share Link"
                    },
                    on: {
                      click: function($event) {
                        _vm.setMeetingLinkModal(true)
                      }
                    }
                  })
                : _vm._e(),
              _vm.meetingLinkModal
                ? _c("ShareMeetingLinkModal", {
                    model: {
                      value: _vm.meetingLinkModal,
                      callback: function($$v) {
                        _vm.meetingLinkModal = $$v
                      },
                      expression: "meetingLinkModal"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._m(2),
    _c("div", { staticClass: "sl-row" }, [
      _c(
        "div",
        { staticClass: "sl-col-6", staticStyle: { "min-height": "50px" } },
        [
          _c("q-checkbox", {
            attrs: { disable: !_vm.canEdit },
            model: {
              value: _vm.currentSession().registrationOpen,
              callback: function($$v) {
                _vm.$set(_vm.currentSession(), "registrationOpen", $$v)
              },
              expression: "currentSession().registrationOpen"
            }
          }),
          _c("span", [_vm._v("Allow Registration For this Session")])
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "sl-col-6" },
        [
          _c(
            "q-field",
            { attrs: { helper: "(Optional)" } },
            [
              _c("q-input", {
                attrs: {
                  "stack-label": "Max # of Students",
                  type: "number",
                  disable:
                    _vm.disableMaxStudentsForCurrentSession() || !_vm.canEdit
                },
                on: {
                  change: function(val) {
                    return _vm.setMaxStudents({})
                  }
                },
                model: {
                  value: _vm.currentSessionOrFirst("MaxStudents").maxStudents,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.currentSessionOrFirst("MaxStudents"),
                      "maxStudents",
                      $$v
                    )
                  },
                  expression: "currentSessionOrFirst('MaxStudents').maxStudents"
                }
              })
            ],
            1
          ),
          _vm.currentSession(true) != 0
            ? _c("q-checkbox", {
                attrs: { disable: !_vm.canEdit },
                model: {
                  value: _vm.currentSessionOrFirst("MaxStudents")
                    .syncMaxStudents,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.currentSessionOrFirst("MaxStudents"),
                      "syncMaxStudents",
                      $$v
                    )
                  },
                  expression:
                    "currentSessionOrFirst('MaxStudents').syncMaxStudents"
                }
              })
            : _vm._e(),
          _vm.currentSession(true) != 0
            ? _c(
                "span",
                {
                  staticClass: "sync-label",
                  staticStyle: { "margin-top": "15px", display: "inline-block" }
                },
                [_vm._v("Sync with First Session")]
              )
            : _vm._e()
        ],
        1
      )
    ]),
    _vm._m(3),
    _c("div", { staticClass: "sl-row" }, [
      _c(
        "div",
        { staticClass: "sl-col-12" },
        [
          _c(
            "q-field",
            {
              attrs: {
                error:
                  _vm.sessionInformation.selectedCourse == null ||
                  _vm.sessionInformation.courses.length === 0,
                "error-label": _vm.courseErrorLabel
              }
            },
            [
              _c("q-select", {
                attrs: {
                  after: [
                    {
                      icon: "flag",
                      condition: _vm.classValidation.selectedCourse.$invalid
                    },
                    {
                      icon: "fa fa-check",
                      condition: !_vm.classValidation.selectedCourse.$invalid
                    }
                  ],
                  "float-label": "Course*",
                  disable:
                    !_vm.canEdit || _vm.sessionInformation.courses.length === 0,
                  options: _vm.getCourses()
                },
                model: {
                  value: _vm.sessionInformation.selectedCourse,
                  callback: function($$v) {
                    _vm.$set(_vm.sessionInformation, "selectedCourse", $$v)
                  },
                  expression: "sessionInformation.selectedCourse"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _c("div", { staticClass: "sl-row" }, [
      _c(
        "div",
        { staticClass: "sl-col-12" },
        [
          _c("q-input", {
            attrs: {
              type: "textarea",
              "inverted-light": "",
              color: "grey-12",
              disable: !_vm.canEdit,
              "float-label": "Notes"
            },
            model: {
              value: _vm.sessionInformation.notes,
              callback: function($$v) {
                _vm.$set(_vm.sessionInformation, "notes", $$v)
              },
              expression: "sessionInformation.notes"
            }
          })
        ],
        1
      )
    ]),
    _c("div", { staticClass: "sl-row" }, [
      _c(
        "div",
        { staticClass: "sl-col-12" },
        [
          !_vm.isFirstSession()
            ? _c(
                "q-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.canEdit,
                      expression: "canEdit"
                    }
                  ],
                  attrs: { color: "negative", outline: "", icon: "delete" },
                  nativeOn: {
                    click: function($event) {
                      _vm.onRemove(_vm.currentSession(true))
                    }
                  }
                },
                [_vm._v("Delete Session")]
              )
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sl-row" }, [
      _c("div", { staticClass: "sl-col-12" }, [
        _c("h5", [_vm._v("Date & Time")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sl-row" }, [
      _c("div", { staticClass: "sl-col-12" }, [
        _c("h5", [_vm._v("Class Type")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sl-row" }, [
      _c("div", { staticClass: "sl-col-12" }, [
        _c("h5", [_vm._v("Registration Options")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sl-row" }, [
      _c("div", { staticClass: "sl-col-12" }, [
        _c("h5", [
          _vm._v("\n        Additional Information\n        "),
          _c("span", [_vm._v("(For All Sessions)")])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }